import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from "@angular/forms";
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {ImageUploadModule} from "../../lib/image-upload/image-upload.module";
import { CandidateRefereeNotesModalComponent } from './candidate-referee-notes-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonModule } from '@xref/xref-lib';
@NgModule({
    declarations: [CandidateRefereeNotesModalComponent],
    imports: [
      CommonModule,
      FormsModule,
      AlertMessageModule,
      TooltipModule.forRoot(),
      ImageUploadModule,
      ReactiveFormsModule,
      ButtonModule
    ],
    exports: [CandidateRefereeNotesModalComponent]
  })
  export class CandidateRefereeNotesModalModule {
  }
